import ShipLaborTally from '@/models/ShipLaborTally'

export default class ShipLaborTallyFetch {
    static of(shipId, sailorId = '', params) {
        return Promise.resolve()
            .then(function () {
                ShipLaborTally.deleteAll()
                return ShipLaborTally.api()
                    .fetch(shipId, sailorId, params)
                    .then()
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
